import {toastStore} from "../store/toast.module.js";
import {reactive} from "vue";

export function copyClipboardText(text) {
    this.$copyText(text)
    toastStore.toasts.push({
        severity: 'success',
        summary: 'Success',
        detail: 'Text copied in clipboard',
        life: 3000,
        id: 1
    })
}

export function getPlanAmount(plan, subscriptionDetails) {
    if (plan.billing_scheme === 'tiered' && subscriptionDetails) {
        let stop = false
        let itemPrice = 0
        const quantity = subscriptionDetails.quantity

        const tiers = plan.tiers.slice().reverse();
        tiers.forEach((tier, index) => {
            if (tier.up_to && tier.up_to < quantity) {
                stop = true;
            }
            if (!stop) {
                itemPrice = tier.unit_amount
            }
        });
        return itemPrice * quantity
    } else {
        return plan.amount
    }
}

export function getPriceFormattedData(plan, subscriptionDetails) {
    const currency = plan.currency.toUpperCase()
    const interval = plan.interval
    const intervalCount = plan.interval_count
    let intervalText = ''

    if (intervalCount > 1) {
        const intervalLabel = interval.charAt(0).toUpperCase() + interval.slice(1)
        intervalText = `${intervalCount}-${intervalLabel}`
    } else {
        if (interval === 'year') {
            intervalText = 'Annual'
        } else {
            intervalText = 'Monthly'
        }
    }

    const amount = getPlanAmount(plan, subscriptionDetails) / 100

    return {
        amount: amount
            .toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
            .replace(/\.00/g, ''),
        currency: currency,
        intervalText: intervalText,
    }
}

export function getDiscountFormattedData(discount) {
    let discountValue = `${discount.percent_off}%`;

    if (discount.amount_off) {
        const currency = discount.currency.toUpperCase()
        discountValue = `${discount.amount_off/100} ${currency}`
    }

    return {
        value: discountValue
            .toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
            .replace(/\.00/g, '')
    }
}
export function getPlanAmountForDiscount(plan, discount) {
    let amount = 0
    const planAmount = plan.amount

    if (discount.amount_off) {
        amount = planAmount - discount.amount_off
    } else {
        amount = planAmount - (planAmount * (discount.percent_off / 100));
    }

    return (amount / 100)
        .toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
        .replace(/\.00/g, '')
}

export function loadJs(jss, callback) {
    jss.forEach(js => {
        const script = document.createElement('script');
        script.src = js;
        script.async = true;
        script.onload = callback;
        document.getElementsByTagName("head")[0].appendChild(script);
    });
}


export function embedComponent(name, params) {
    window.top.postMessage({'outpostEmbedComponent': {
        name: name,
        params: params
    }}, "*");
}

export function isGroupSubscriptionOffer(planId) {
    return planId && planId.includes('gs_')
}

export function deepCopyReactive(obj) {
    return reactive(JSON.parse(JSON.stringify(obj)))
}

export function hasObjectChanged(original, copy) {
    for (const key in original) {
        if (typeof original[key] === 'object' && original[key] !== null && typeof copy[key] !== 'undefined') {
            if (hasObjectChanged(original[key], copy[key])) {
                return true;
            }
        } else {
            if (typeof copy === 'undefined' || original[key] !== copy[key]) {
                return true;
            }
        }
    }
    return false;
}

export function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
